// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__+fAkv","pageBtn":"Pagination_pageBtn__ErE9s","active":"Pagination_active__8lC-w"};